export const C_CONDICTION_PROPERTY = {
  NEW: {
    name: "Nuevo",
    id: 0,
    value: "unused",
    label: "Nueva",
    color: "#8CC63F"
  },
  RESALE: {
    name: "Reventa",
    id: 1,
    value: "used",
    label: "Reventa",
    color: "#D90921"
  },
  USED: {
    name: "Usado",
    id: 1,
    value: "used",
    label: "Usado",
    color: "#D90921"
  }
};

export interface I_ConditionStatus {
  name: string;
  id: number;
  value: string;
  label: string;
  color: string;
}

export interface ConditionStatusMap {
  [name: string]: I_ConditionStatus;
}

export const O_CONDICTION_PROPERTY_FOR_NAME = {
  [C_CONDICTION_PROPERTY.NEW.name]: C_CONDICTION_PROPERTY.NEW,
  [C_CONDICTION_PROPERTY.RESALE.name]: C_CONDICTION_PROPERTY.RESALE,
  [C_CONDICTION_PROPERTY.USED.name]: C_CONDICTION_PROPERTY.USED
};

export const A_CONDICTION_PROPERTY = [
  C_CONDICTION_PROPERTY.NEW,
  C_CONDICTION_PROPERTY.RESALE
];
